module.exports = __webpack_public_path__ + "img/CDNX-logo_small.32cf96.svg";